module.exports = __webpack_public_path__ + "static/media/received_10156640269624152.f2400d1f.jpg";